import React from 'react'
import HealthcareBanner from '../Healthcare/HealthcareBanner';
import HealthcareExcellence from '../Healthcare/HealthcareExcellence';
import HealthcareFacility from '../Healthcare/HealthcareFacility';
import HealthcareCounter from '../Healthcare/HealthcareCounter';
import HealthcareSmart from '../Healthcare/HealthcareSmart';
import HealthcarePremise from '../Healthcare/HealthcarePremise';
import HealthcareBrand from '../Healthcare/HealthcareBrand';
import HealthcareBusinesse from '../Healthcare/HealthcareBusinesse';
import HealthcareFaq from '../Healthcare/HealthcareFaq';
import HomeProducts from '../../home/HomeProducts';

export default function Railways({initialData}) {

    const bannerData = {
        head: "Home",
        breadcrumb: [
            {
                slug: "/railway-grade-commercial-laundry-machiney",
                name: "Railway"
            }
        ]

    }




    const Banner = {
        buttonText: "Global Markets",
        buttonLink: "/markets",
        title: "Railway-Grade Laundry Systems",
        description: "Heavy-duty washing systems engineered for nonstop railway operations, efficiently handling coach bedding, staff uniforms, and pantry linens at scale. Designed for industrial durability and high-load capacity, these solutions deliver rapid turnaround, energy efficiency, and 24×7 reliability—ensuring hygiene standards are maintained and trains stay on schedule without disruption.",
        image: "/assets/images/railway-banner1.webp"
    };

    const excellenceData = {
        subtitle: "Railway-Grade Engineering",
        title: "When Downtime <br> Isn't an Option",
        description1: "Indian Railways processes over 8 million passenger journeys daily. Every coach needs fresh bedding. Every pantry car requires clean linens. Every uniform must meet hygiene standards. Your laundry operation isn't a support function—it's critical infrastructure that keeps the network moving.",
        description2: "Supershine engineers systems for railway realities: continuous operation, extreme volumes, tough contamination, and zero tolerance for equipment failure. We've equipped 200+ railway laundries because we build for industrial punishment, not light commercial use.",
        buttonText: "Talk to Our Experts",
        buttonLink: "/contact"
    };


    const facilityData = {
        title: "Built for Railway Operations",
        items: [
            {
                icon: "/assets/images/railways-icon1.webp",
                heading: "Extreme Load Capacity",
                description: "Processes heavy coach blankets, thick curtains, and bulk uniform loads that would destroy standard commercial equipment within months."
            },
            {
                icon: "/assets/images/railways-icon2.webp",
                heading: "Continuous Operations",
                description: "Engineered for true 24×7 railway scheduling with reinforced components, advanced cooling, and no duty cycle limitations ever."
            },
            {
                icon: "/assets/images/railways-icon3.webp",
                heading: "Contamination Removal",
                description: "Eliminates coal dust, grease, oil, food stains, and railway-specific soiling that defeats normal laundry chemistry and mechanics."
            },

            {
                icon: "/assets/images/railways-icon4.webp",
                heading: "Multi-Zone Deployment",
                description: "Standardized systems across zones ensure consistent quality whether processing in Mumbai, Delhi, or remote depot facilities nationwide."
            },

            {
                icon: "/assets/images/railways-icon5.webp",
                heading: "Minimal Downtime",
                description: "Designed for quarterly servicing, not weekly repairs, keeping equipment running through peak seasons without operational disruptions."
            },


            {
                icon: "/assets/images/railways-icon6.webp",
                heading: "Utility Efficiency",
                description: "Cuts water and energy consumption 30% despite heavy loads, reducing infrastructure costs across large railway laundry networks."
            }
        ]
    };


    const HeathCareCounter = {
        title: "Proven Railway Performance",
        stats: [
            {
                end: 200,
                suffix: "+",
                text: " Railway <br> Laundries  Operating",
            },
            {
                end: 24,
                suffix: "*7",
                text: "Continuous <br> Processing   Capability",
            },
            {
                end: 99,
                suffix: "%",
                text: "Hygiene <br> Compliance   Achieved",
            },
            {
                prefix: "",
                end: 30,
                suffix: "%",
                text: "Operating <br> Cost   Reduction",
            },
        ],
    };

    const Fashionsmart = {
        extraClass: "",
        heading: `Engineering That Matches Railway Scale`,
        description: "Railway laundries face demands no hotel or hospital experiences: extreme volumes, harsh contamination, continuous schedules, and distributed operations. Our systems deliver the overbuilt durability, processing power, and network consistency railway infrastructure requires.",
        buttonText: "Discuss Your Requirements",
        buttonLink: "/about",
        altText: "Smart"
    };


    const PremiseData = {
        image: "/assets/images/railways-left-image.webp",
        title: "What Railway Operations Actually Need",
        subtitle: "The Infrastructure Advantage:",
        reasons: [
            "Maintain passenger standards consistently through validated hygiene protocols processing thousands of coach linens daily across multiple shifts continuously.",
            "Handle depot volumes reliably with equipment engineered for railway-scale throughput—not commercial capacity stretched beyond design limits dangerously.",
            "Remove railway-specific contamination effectively using industrial wash mechanics, specialized chemistry, and temperature control defeating coal dust and grease.",
            "Standardize quality across zones through identical equipment specifications, uniform protocols, and centralized training ensuring passenger experience consistency nationwide.",
            "Minimize infrastructure downtime through ruggedized construction, redundant systems, rapid parts availability, and preventive maintenance during scheduled windows only."
        ],
        buttonText: "Plan Your Railway Laundry Setup",
        buttonLink: "/contact"
    };


    const healthcareBrandData = {
        title: "",
        logos: [
            { image: "/assets/images/home-brand-logos3.webp", title: "Brand 1" },
            { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
            { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
            { image: "/assets/images/hospital-new-img1.webp", title: "Brand 4" },
            { image: "/assets/images/hospital-new-img2.webp", title: "Brand 5" },
            { image: "/assets/images/hospital-new-img3.webp", title: "Brand 6" },
            { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
            { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
        ]
    };



    const businessData = {
        title: "Endorsed By Railway  <br/> Operations Teams.",
        description:
            "Round the clock operation and high-volume processing make Supershine the preferred choice for institutional railway laundry solutions.",
        testimonials: [
            {
                rating: 5,
                text:
                    "“Processing linen and uniforms for a railway division means dealing with volumes that don't allow for downtime. Supershine's equipment has handled our daily load consistently, even during peak travel seasons when demand spikes sharply. The build quality has stood up well to round the clock operation, which was our biggest concern going in.”",
                client: "Subodh Pandey, Maintenance Supervisor, Railway Linen Facility",
            },
            {
                rating: 5,
                text:
                    "“Hygiene standards for passenger linen are non-negotiable, and our old machines were struggling to keep pace with demand while maintaining quality. Since Supershine's installation, we've seen far more consistent results across every batch, and our turnaround time has improved enough to keep up with increased train frequency on our routes.”",
                client: "Harpreet Singh, Facility In-Charge, Railway Laundry Unit",
            },
            {
                rating: 5,
                text:
                    "“Continuous operation is the norm for us, and equipment failure has real downstream effects on service readiness. Supershine's machines have run reliably through extended shifts without the frequent breakdowns we used to deal with. Their team's understanding of high-volume institutional laundry made the transition far smoother than we expected.”",
                client: "Ramesh Yadav, Operations Officer, Railway Maintenance Division",
            },
        ],
    };



    const productData = {
        subtitle: "Recommended Products",
        title: "High-Capacity Laundry Systems  <br> for Indian Railways",
    };


    const faqData = {
        title: "FAQs",
        description: "Direct answers for railway infrastructure planning and procurement decisions.",
        buttonText: "Talk to an expert",
        buttonLink: "/contact",
        faqs: [
            {
                question: "What makes railway laundry different from commercial operations?",
                answer: "Railway laundries face unique demands: extreme volumes (500-1000+ loads daily), continuous 24×7 operation, harsh contamination (coal, grease, oils), distributed multi-zone deployment, and critical infrastructure status.",
            },
            {
                question: "Can equipment truly operate 24×7 without breaks?",
                answer: "Yes. Our railway systems feature continuous-duty motors, industrial cooling, reinforced bearings, heavy-gauge construction, and no duty-cycle limitations. Unlike commercial equipment rated for intermittent use, these machines are engineered for literally nonstop operation across three shifts daily.",
            },
            {
                question: "How do you handle railway-specific contamination like coal dust?",
                answer: "Specialized wash mechanics use higher mechanical action, extended pre-wash cycles, industrial-strength chemistry, elevated temperatures, and multiple rinse stages. Standard programs can't remove railway soiling, our protocols are developed specifically for coal dust, grease, and oil removal.",
            },

            {
                question: "What's required for multi-zone railway deployment?",
                answer: "Standardized equipment specifications across zones, uniform operating protocols, centralized training programs, zone-specific parts inventory, regional service support, and performance monitoring ensure consistent quality whether operating in major cities or remote depot facilities nationwide.",
            },

            {
                question: "How do you minimize maintenance impact on operations?",
                answer: "Systems are designed for quarterly preventive maintenance during scheduled windows, not weekly repairs. Redundant components, robust construction, predictive monitoring, and rapid parts availability keep equipment running. Most maintenance happens during planned downtime, not emergency failures.",
            },

            {
                question: "What's the typical service life for railway laundry equipment?",
                answer: "Railway-grade systems deliver 15-20 years under continuous operation with proper maintenance; significantly longer than commercial equipment. Industrial construction, heavy-duty components, and overengineered design withstand railway punishment that destroys standard machines within 3-5 years.",
            },
        ],
    };

    return (
        <>

            <HealthcareBanner data={Banner} breadcrumb={bannerData.breadcrumb}/>
            <HealthcareExcellence data={excellenceData} />
            <HealthcareFacility data={facilityData} />
            <HealthcareCounter data={HeathCareCounter} />
            <HealthcareSmart data={Fashionsmart} />
            <HealthcarePremise data={PremiseData} />
            <HealthcareBrand data={healthcareBrandData} />
            <HealthcareBusinesse data={businessData} />
            <HomeProducts data={productData} extraClass="healthcare-product" initialData={initialData}/>
            <HealthcareFaq data={faqData} />
        </>
    )
}










